import { PropsWithChildren } from 'react';
import { ThemeProvider as MaterialThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { AlertProvider } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Alert';
import { ModalProvider } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal/providers/ModalProvider';
import TourProvider from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Tour/TourProvider';
import studentAppTheme from '@monorepo/shared/src/themes/studentAppTheme';
import PageProvider from '@monorepo/shared/src/providers/PageProvider';
import { A11ySettingsProvider } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@a11y/A11ySettings/state/A11ySettingsProvider';
import ActivityAudioProvider from '@monorepo/shared/src/providers/ActivityAudioProvider';
import { AudioPlayerProvider } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/AudioManager';
import { RouteGuardProvider } from 'state/hooks/use-route-guard';
import InstructionButtonProvider from './InstructionsButtonProvider';

const BaseAppProviders: React.FC<PropsWithChildren<any>> = ({ children }) => {
  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <StyledEngineProvider injectFirst>
        <MaterialThemeProvider theme={studentAppTheme}>
          <A11ySettingsProvider>
            <ActivityAudioProvider>
              <AudioPlayerProvider useNativeAudioPlayer>
                <PageProvider>
                  <AlertProvider>
                    <ModalProvider>
                      <RouteGuardProvider>
                        <TourProvider>
                          <InstructionButtonProvider>{children}</InstructionButtonProvider>
                        </TourProvider>
                      </RouteGuardProvider>
                    </ModalProvider>
                  </AlertProvider>
                </PageProvider>
              </AudioPlayerProvider>
            </ActivityAudioProvider>
          </A11ySettingsProvider>
        </MaterialThemeProvider>
      </StyledEngineProvider>
    </QueryParamProvider>
  );
};

export default BaseAppProviders;
